import { Box, Paper, PaperProps } from '@mui/material';

interface ComplianceSectionBlockProps extends PaperProps {
  header: React.ReactNode;
}

const ComplianceSectionBlock = ({ header, children, ...props }: ComplianceSectionBlockProps) => {
  return (
    <Paper elevation={0} {...props}>
      <Box
        sx={{
          minHeight: 68,
          display: 'flex',
          alignItems: 'center',
          px: 2,
          borderBottom: '1px solid var(--mui-palette-border-default)',
        }}
      >
        {header}
      </Box>

      <Box sx={{ p: 0 }}>{children}</Box>
    </Paper>
  );
};

export default ComplianceSectionBlock;
